<template>
	<div class="ov-dropdown" ref="root">
		<div class="ov-dropdown__main">
			<OvButton variant="primary" :type="submitMain ? 'submit' : 'button'" @click="onMainClick">
				{{ text }}
			</OvButton>
			<button type="button" class="ov-dropdown__toggle" @click="open = !open">
				<i class="la la-angle-down" />
			</button>
		</div>
		<div v-if="open" class="ov-dropdown__menu">
			<slot />
		</div>
	</div>
</template>

<script>
import OvButton from "./OvButton.vue";

export default {
	name: "OvDropdown",
	components: { OvButton },
	props: {
		text: { type: String, default: "Go" },
		split: { type: Boolean, default: true },
		submitMain: { type: Boolean, default: false },
	},
	emits: ["main-click"],
	data() {
		return { open: false };
	},
	mounted() {
		document.addEventListener("click", this.onOutsideClick);
	},
	beforeUnmount() {
		document.removeEventListener("click", this.onOutsideClick);
	},
	methods: {
		onMainClick(e) {
			if (!this.submitMain) {
				this.$emit("main-click", e);
			}
		},
		onOutsideClick(e) {
			if (this.$refs.root && !this.$refs.root.contains(e.target)) {
				this.open = false;
			}
		},
		close() {
			this.open = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.ov-dropdown {
	position: relative;
	display: inline-flex;

	&__main {
		display: flex;
	}

	&__toggle {
		padding: 0 10px;
		background: var(--ds-color-primary-hover);
		color: #fff;
		border: none;
		border-left: 1px solid rgba(255, 255, 255, 0.2);
		border-radius: 0 var(--ds-radius-sm) var(--ds-radius-sm) 0;
		cursor: pointer;

		:deep(+ .ov-btn) {
			border-radius: var(--ds-radius-sm) 0 0 var(--ds-radius-sm);
		}
	}

	:deep(.ov-btn--primary) {
		border-radius: var(--ds-radius-sm) 0 0 var(--ds-radius-sm);
	}

	&__menu {
		position: absolute;
		top: 100%;
		right: 0;
		z-index: 100;
		min-width: 140px;
		margin-top: 4px;
		padding: 4px 0;
		background: var(--ds-color-surface);
		border: 1px solid var(--ds-color-border);
		border-radius: var(--ds-radius-sm);
		box-shadow: var(--ds-shadow-lg);
	}
}
</style>
